module.exports = __webpack_public_path__ + "static/media/a1049d00-54ad-4589-95b8-d353f7ab52f0-greek.5512a2ce.woff2";